import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { ApplicationInsightsService } from "../../main/services/applicationInsights.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable()

export class GlobalErrorHandler extends ErrorHandler {

    constructor(private injector: Injector, 
        public translateService: TranslateService
    ) {
        super();
    }

    handleError(error: Error) {
        const chunkFailedMessage = "chunkloaderror: loading chunk";
        if (error.message.toLowerCase().includes(chunkFailedMessage)) {
            this.injector.get<ApplicationInsightsService>(ApplicationInsightsService).logException(error);
            this.reloadWindow();
        }  
        if(error.message.includes("AADB2C90118:")){                   
            console.log("Error occurred: " + error.message);     
            alert(this.translateService.instant('ForgetPasswordWarningMessage'));  
        }    
        this.injector.get<ApplicationInsightsService>(ApplicationInsightsService).logException(error);
        super.handleError(error);
    }

    public reloadWindow() {
        window.location.reload();
    }

}
